import _ from 'lodash';
import { KendoGridHelper } from '@/helpers';


export default {
    watch: {
        'gridDataSource.data': {
            deep: true,
            handler: _.debounce(function (newValue) {
                if (this.$refs.gridDataSource) {
                    this.$refs.gridDataSource.kendoDataSource.data(newValue);
                }
            }, 100, {
                leading: true,
                trailing: false
            })
        }
    },
    methods: {
        getKendoGridHelper(e) {
            if (typeof e === 'string') return new KendoGridHelper(this.$refs[e].kendoWidget());
            return new KendoGridHelper(e);
        }
    }
};
